export default {
  RENTER_HUB: {
    CONFIRM_RENT_DETAILS: {
      RENT_PAYMENT: {
        FIRST_DUE_DATE: 'renterHub confirmRentDetails rentPayment firstDueDate',
        LAST_DUE_DATE: 'renterHub confirmRentDetails rentPayment lastDueDate',
      },
      MOVE_IN_COSTS: {
        DUE_DATE: 'renterHub confirmRentDetails moveInCosts dueDate',
      },
    },
    PAYMENTS_SETTINGS: {
      RENT_PAYMENT: {
        DUE_DATE: 'renterHub paymentSettings rentPayment dueDate',
      },
    },
    RENTER_DASHBOARD: {
      RENT_PAYMENT: {
        DUE_DATE: 'renterHub renterDashboard rentPayment dueDate',
      },
      MOVE_IN_COSTS: {
        DUE_DATE: 'renterHub renterDashboard moveInCosts dueDate',
      },
    },
  },
};
